import { Component, OnInit } from '@angular/core';
import { API } from 'src/app/services/api.service';
import { alertService } from 'src/app/services/alert-service.service';

@Component({
  selector: 'app-return-review',
  templateUrl: './return-review.component.html',
  styleUrls: ['./return-review.component.css']
})
export class ReturnReviewComponent implements OnInit {
  checkInputCert: boolean = false;
  loaderCert: boolean = false;
  leed_id: any = ''

  constructor(
    private api: API,
    private alertService: alertService
  ) { }

  checkInputsCert() {
    if (isNaN(this.leed_id)) {
      this.checkInputCert = false;
    }
    else {
      this.checkInputCert = true;
    }
  };
  
  returnReview() {
    this.loaderCert = true;
    this.api.get('/assets/LEED:' + this.leed_id + '/review/return/').subscribe(
      data => {
        this.loaderCert = false;
        this.alertService.alert('success', data.message, 5);
      },
      error => {
        this.loaderCert = false;
        this.alertService.alert('error', 'Something went wrong. Please try again.', 5);
      }
    );
  }

  ngOnInit(): void {
  }

}
